import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import BlogList from "./list";
import BlogSubscribersList from "./subscribers";

const tabs = [
  { label: "blogList", value: "blog_list" },
  { label: "blogSubscribers", value: "blog_subscribers" },
];

function BlogSection() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, blogs: tab }));
  };

  const renderTabContent = () => {
    switch (activeTab.blogs) {
      case "blog_list":
        return <BlogList handleChangeTab={handleChangeTab} />;
      case "blog_subscribers":
        return <BlogSubscribersList handleChangeTab={handleChangeTab} />;
      default:
        return null;
    }
  };


  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading="blogs"
            tabs={tabs}
            activeTab={activeTab.blogs}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {renderTabContent()}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default BlogSection;
